/* eslint-disable sonarjs/no-clear-text-protocols */
import { AppRoutes, StorageRoutes } from '@bn/dashboard-core/enums';
import { EnvConfig } from '@bn/shared/entities/index';
import { ExternalUrlConfig } from '@bn/web-ui/external-url';

export class ExtUrlConfiguration {
  public urls!: ExternalUrlConfig;

  constructor(envConfig: EnvConfig) {
    this.urls = {
      learn: {
        [AppRoutes.Storage]: {
          [StorageRoutes.root]: `${envConfig.apiDocsBunnyUrl}/storage`,
          [StorageRoutes.fileManager]: `${envConfig.apiDocsBunnyUrl}/storage/dashboard`,
          [StorageRoutes.access]: `${envConfig.apiDocsBunnyUrl}/storage/ftp`,
          [StorageRoutes.replication]: `${envConfig.apiDocsBunnyUrl}/storage/replication`,
          [StorageRoutes.pullZones]: `${envConfig.apiDocsBunnyUrl}/storage/quickstart`,
          [StorageRoutes.errorHandling]: `${envConfig.apiDocsBunnyUrl}/storage/settings#error-handling`,
        },
      },
      docsBunnyNet: {
        apiReference: {
          apiOverview: {
            name: 'BunnyNet Api Docs',
            url: `${envConfig.apiDocsBunnyUrl}/reference/bunnynet-api-overview`,
          },
          StorageOverview: {
            name: 'Storage Api Docs',
            url: `${envConfig.apiDocsBunnyUrl}/reference/storage-api`,
          },
          StreamOverview: {
            name: 'Stream Api Docs',
            url: `${envConfig.apiDocsBunnyUrl}/reference/stream-api-overview`,
          },
        },
        docs: {
          streamWebhook: {
            name: 'Stream Webhook Docs',
            url: `${envConfig.apiDocsBunnyUrl}/docs/stream-webhook`,
          },
          streamSecurity: {
            name: 'Stream Security Docs',
            url: `${envConfig.apiDocsBunnyUrl}/docs/stream-security`,
          },
          computeScripts: {
            name: 'Compute scripts Docs & Examples',
            url: `${envConfig.apiDocsBunnyUrl}/docs/getting-started`,
          },
          edgeRulesVariableExpansion: {
            name: 'Variable Expansion documentation',
            url: `${envConfig.apiDocsBunnyUrl}/docs/edge-rules-variable-expansion`,
          },
          bunnyAIImageGeneration: {
            name: 'Bunny AI Image Generation',
            url: `${envConfig.apiDocsBunnyUrl}/docs/bunny-ai-image-generation`,
          },
          bunnyAIImageGenerationPromptSuggestions: {
            name: 'Bunny AI Image Generation Prompt Suggestions',
            url: `${envConfig.apiDocsBunnyUrl}/docs/bunny-ai-image-generation#prompt-suggestions`,
          },
          bunnyAIImageGenerationBlueprints: {
            name: 'Bunny AI Image Generation Blueprints',
            url: `${envConfig.apiDocsBunnyUrl}/docs/bunny-ai-image-generation#blueprints`,
          },
        },
      },
      supportBunnyNet: {
        hub: {
          engagementScoreTagging: {
            url: `${envConfig.supportBunnyUrl}/hc/en-us/articles/#`,
          },
          streamContentTagging: {
            url: `${envConfig.supportBunnyUrl}/hc/en-us/articles/4412240806802-Understanding-Bunny-Stream-Content-Tagging`,
          },
          knowledgeBase: {
            url: `${envConfig.supportBunnyUrl}/hc/en-us/`,
          },
          sslSetupCustomDomain: {
            name: 'Setup SSL tutorial',
            url: `${envConfig.supportBunnyUrl}/hc/en-us/articles/208517725-How-to-set-up-SSL-for-your-custom-domain-name`,
          },
          dnsKnowledgebase: {
            name: 'DNS Knowledgebase',
            url: 'https://support.bunny.net/hc/en-us/categories/7247459248530-DNS',
          },
          bunnyRoutingFilters: {
            name: 'Routing Filters',
            url: `${envConfig.supportBunnyUrl}/hc/en-us/articles/8382230428060-Understanding-Routing-Filters`,
          },
        },
      },
      statusBunnyNet: {
        serviceStatus: {
          url: envConfig.statusUrl,
        },
      },
      toolsBunnyNet: {
        diagnosticReportUrl: {
          name: 'Run diagnostic report',
          url: `${envConfig.toolsUrl}/diagnostic-report`,
        },
      },
      externalServices: {
        gtMetrixUrl: {
          name: 'Open GTMetrix',
          url: 'https://www.gtmetrix.com',
        },
        tracerouteUrl: {
          name: 'How to open traceroute',
          url: 'https://support.bunny.net/hc/en-us/articles/115002047172-How-do-I-run-a-traceroute',
        },
      },
      authenticatorDownloadUrl: {
        android: {
          name: 'Android',
          url: 'http://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en',
        },
        ios: {
          name: 'Iphone',
          url: 'http://apps.apple.com/us/app/google-authenticator/id388497605',
        },
      },
    };
  }

  getUrls(): ExternalUrlConfig {
    return this.urls;
  }
}
